import { inject, Injectable } from '@angular/core';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { catchError, filter, tap } from 'rxjs/operators';
import { ErrorChangeAccountMsgEng } from '../../../custom-header/header.constants';
import * as config from '../../config/app.config';
import { FITUSIRAN_FLAGS, WAYRILZ_FLAGS } from '../../config/app.config';
import { BaseService } from '../../services/base.service';
import { SharedService } from '../../services/shared.service';


@Injectable({
  providedIn: 'root'
})
export class LoactionStripService {
  private readonly sharedService = inject(SharedService);
  private readonly baseService = inject(BaseService);
  private readonly globalMessage = inject(GlobalMessageService);

  userAccountType: any;
  userAccountData = new BehaviorSubject<any>(false);
  userAccountData$ = this.userAccountData.asObservable();
  errorMessageText: string = ErrorChangeAccountMsgEng;
  public userAccountDetails = new BehaviorSubject<any>(false);
  userAccountDetails$ = this.userAccountDetails.asObservable();
  public userAccountAddressDetails = new Subject<any>();
  userAccountAddressDetails$ = this.userAccountAddressDetails.asObservable();
  public endSession = new BehaviorSubject<any>(false);
  endSession$ = this.endSession.asObservable();
  emitSelectedLocs = new BehaviorSubject<any>(false);
  emitSelectedLocs$ = this.emitSelectedLocs.asObservable();
  openModal = new BehaviorSubject<boolean>(false);
  openModal$ = this.openModal.asObservable();
  $shipToAddress = new Subject<any>();
  soldToLocations: Array<any>;
  $shipToMultiple = new BehaviorSubject<any>(false);

  public getUserAccountDataFromDb(userId): void {
    this.baseService
      .get(config.USER_ACCOUNT + userId + '/b2bUnits', { fields: 'FULL' })
      .subscribe((res) => {
        if (res) {
          this.userAccountType = res.type;
          this.userAccountData.next({ res });
        }
      });
  }

  public getUserAccountAddressesDataFromDb(userId): void {
    this.baseService
      .get(config.USER_ACCOUNT + userId + '/accounts', { fields: 'FULL' })
      .subscribe((res) => {
        this.userAccountAddressDetails.next({ res });
      });
  }

  public getShipToToAddress(userId, sapCustomerId): void {
    if (sapCustomerId != undefined) {
      this.baseService
        .get(config.USER_ACCOUNT + userId + '/units/' + sapCustomerId + '/addresses/shipto', { fields: 'FULL' })
        .subscribe((res) => {
          this.$shipToAddress.next({ res });
          if (res?.addresses.length > 1) {
            this.$shipToMultiple.next(true);
          } else {
            this.$shipToMultiple.next(false);
          }
        });
    }
  }

  public saveSelectedAccount(userId, b2bUnitId): Observable<void> {
    return this.baseService.put(config.USER_ACCOUNT + userId + '/selectedUnit/' + b2bUnitId, { fields: 'FULL' })
      .pipe(
        catchError((err, caught) => {
          window.scroll(0, 0);
          this.globalMessage.add(this.errorMessageText, GlobalMessageType.MSG_TYPE_ERROR);

          return caught;
        })
      );
  }

  public saveSelectedShipToAddress(userId, b2bUnitId, setDefault?): Observable<any> {
    if (!b2bUnitId) {
      return of(null);
    }
    return this.baseService.postBody(config.USER_ACCOUNT + userId + '/selected-shipto-unit/', b2bUnitId, setDefault)
      .pipe(
        filter(Boolean),
        tap((res: any) => {
          if (res?.fitusiransUnitSelected) {
            this.sharedService.setSessionStorage(FITUSIRAN_FLAGS.FITUSIRAN_UNIT_SELECTED, res?.fitusiransUnitSelected)
          }
          if (res?.wayrilzUnitSelected) {
            this.sharedService.setSessionStorage(WAYRILZ_FLAGS.WAYRILZ_UNIT_SELECTED, res?.wayrilzUnitSelected)
          }
        }),
        catchError((err, caught) => {
          console.error('error', err);
          window.scroll(0, 0);
          this.globalMessage.add(this.errorMessageText, GlobalMessageType.MSG_TYPE_ERROR);
          return caught;
        })
      );
  }

  public disableLocStrip(endSessionFlag): void {
    this.endSession.next(endSessionFlag);
  }

}
